<template>
    <MainComponent :id="anchorsPageProfile.similarProfilesSection" data-testid="similar-profiles">
        <template #title>
            <h2>{{ t('profile.section.similar.title') }}</h2>
        </template>
        <template #title-action>
            <VJoyWrapper
                v-if="!blurSimilarProfiles && hasSimilarProfiles"
                class="similar-profiles__navigation"
                no-margin
                wrap="nowrap"
                column-gap="2"
            >
                <VJoyIconButton
                    data-testid="similar-profiles-navigation-left"
                    variant="ghost"
                    icon="chevron-left"
                    size="small"
                    @click="previousProfile()"
                />
                <VJoyIconButton
                    data-testid="similar-profiles-navigation-right"
                    variant="ghost"
                    icon="chevron-right"
                    size="small"
                    @click="nextProfile()"
                />
            </VJoyWrapper>
        </template>
        <template #content>
            <FakeSimilarProfilesList v-if="blurSimilarProfiles" />
            <SimilarProfilesList v-else-if="hasSimilarProfiles" :similar-profiles="similarProfiles ?? []" />
        </template>
    </MainComponent>
</template>
<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {VJoyWrapper, VJoyIconButton} from '@maltjoy/core-vue';
    import MainComponent from '~/components/main/common/MainComponent.vue';
    import {anchorsPageProfile} from '~/config/anchors';
    import {eventBus} from '~/config/events';
    import FakeSimilarProfilesList from '~/features/similar-profiles/ui/FakeSimilarProfilesList.vue';
    import SimilarProfilesList from '~/features/similar-profiles/ui/SimilarProfilesList.vue';
    import {useSectionsVisibilityStore} from '~/store/sectionsVisibility';
    import {useSimilarProfileStore} from '~/store/similars/similarProfiles.store';

    const sectionsVisibilityStore = useSectionsVisibilityStore();
    const similarProfileStore = useSimilarProfileStore();
    const {hasSimilarProfiles, blurSimilarProfiles} = storeToRefs(sectionsVisibilityStore);
    const {similarProfiles} = storeToRefs(similarProfileStore);

    const {t} = useTranslation();

    function previousProfile() {
        eventBus.emit('similarProfiles:previous');
    }

    function nextProfile() {
        eventBus.emit('similarProfiles:next');
    }
</script>
<style scoped lang="scss">
    @use '@malt/joy-entrypoint' as joy;

    .similar-profiles {
        &__navigation {
            display: none;

            @include joy.screen_xs(min) {
                display: flex;
            }
        }
    }
</style>
